import React, {Fragment} from 'react';
import Box from '../layout/Box';
import createEditor from '../form/ComponentEditor';
import {postData} from "../../utils/request";
import Button from "../form/Button";
import BoxEditor from "./BoxEditor";
import ShippingOrderList from "./lists/shippingorderList";
import ShippingOrderForm from "./forms/shippingorderForm";

class shippingorderEditor extends React.Component {

    shippingDelivered = async () => {
        const values = this.props.values;
        values.autocheckup = true;
        await this.props.processAction(async () => {
            return await postData({
                action: 'shippingorder.shippingDelivered',
                data: values
            });
        });
    }

    render() {
        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        return (
            <Fragment>
                <List
                    {...this.props}
                    theme="default"
                >
                    <ShippingOrderList ref={(el) => this.list = el} {...this.props} loadForm={this.props.loadForm} />
                </List>
                <Editor
                    {...this.props}
                    ref={(editor) => this.editor = editor}
                    theme="default"
                    footer={[
                        <Button key="0" disabled={ this.props.isLoading } color="primary" className="pull-right" onClick={ this.shippingDelivered }>Kiszállítva</Button>
                    ]}
                >
                    <ShippingOrderForm {...this.props} />
                </Editor>
            </Fragment>
        );
    }
}
export default createEditor({componentName: "shippingorder", WrappedComponent: shippingorderEditor});

